const STORE_DATA = {
  "smoked": [
    {
      "id": 9404471804156,
      "title": "Buy 1 kg super jumbo shrimp get 100g smoked salmon slices FREE",
      "handle": "buy-1-kg-super-jumbo-shrimp-get-100g-smoked-salmon-slices-free",
      "price": "1499.00",
      "compare_at_price": "1748.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4537.png?v=1785017348",
      "variant_id": 50646196355324,
      "available": true
    },
    {
      "id": 9404873113852,
      "title": "Smoked Salmon Family Pack — 3×200g + 4×100g",
      "handle": "smoked-salmon-family-pack",
      "price": "2099.00",
      "compare_at_price": "2493.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4544.png?v=1785070697",
      "variant_id": 50647794712828,
      "available": true
    },
    {
      "id": 9404464562428,
      "title": "Buy 3 smoked salmon slices 200g get 200g FREE",
      "handle": "buy-3-smoked-salmon-slices-200g-get-200g-free",
      "price": "1497.00",
      "compare_at_price": "1996.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4536.png?v=1785016542",
      "variant_id": 50646183346428,
      "available": true
    },
    {
      "id": 9404446343420,
      "title": "Buy 4 smoked salmon slices 100g Get 100g FREE",
      "handle": "buy-4-smoked-salmon-slices-100g-get-100g-free",
      "price": "996.00",
      "compare_at_price": "1245.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4535.png?v=1785016189",
      "variant_id": 50646161981692,
      "available": true
    },
    {
      "id": 9347596157180,
      "title": "Smoked Salmon Slices - 100g",
      "handle": "smoked-salmon-slices-100g",
      "price": "249.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/64897525-F4E2-4338-B439-F70053AB0B29.png?v=1780864418",
      "variant_id": 49150741315836,
      "available": true
    },
    {
      "id": 9347597074684,
      "title": "Smoked Salmon Slices - 1Kg",
      "handle": "smoked-salmon-slices-1kg",
      "price": "1699.00",
      "compare_at_price": "2199.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/AEB6636A-5284-450F-8081-EE3A27359864.png?v=1780864095",
      "variant_id": 49150746558716,
      "available": true
    },
    {
      "id": 9347596452092,
      "title": "Smoked Salmon Slices - 200g",
      "handle": "smoked-salmon-slices-200g",
      "price": "499.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-3822.png?v=1780863270",
      "variant_id": 49150745346300,
      "available": true
    },
    {
      "id": 9347597795580,
      "title": "Smoked Salmon Trimmings - 250g",
      "handle": "smoked-salmon-trimmings-250g",
      "price": "279.00",
      "compare_at_price": "0.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/14876A8E-1018-4340-850A-9827F3A6089E.png?v=1780863787",
      "variant_id": 49150747738364,
      "available": true
    },
    {
      "id": 9352779497724,
      "title": "Premium Salmon Trimmings — 1kg 4 packs * 250g",
      "handle": "premium-salmon-trimmings-buy-3-get-1-free-value-pack",
      "price": "899.00",
      "compare_at_price": "1116.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/411BF9D6-2BA0-4AEA-8D9F-E626CEE1998F.png?v=1783410399",
      "variant_id": 49176380801276,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    }
  ],
  "shrimps": [
    {
      "id": 9404912140540,
      "title": "Buy 2 medium shrimp 400g get 1 small shrimp 400g FREE",
      "handle": "buy-2-medium-shrimp-400g-get-1-small-shrimp-400g-free",
      "price": "1098.00",
      "compare_at_price": "1497.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.44.07PM.jpg?v=1785073503",
      "variant_id": 50647865327868,
      "available": true
    },
    {
      "id": 9404475310332,
      "title": "Buy 2 Super Jumbo Shrimp 400g — Get Medium Shrimp 400g FREE",
      "handle": "super-jumbo-shrimp-offer-2plus1",
      "price": "1498.00",
      "compare_at_price": "2047.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4538.png?v=1785066054",
      "variant_id": 50646201336060,
      "available": true
    },
    {
      "id": 9404907225340,
      "title": "Mini Box — Weeknight Starter",
      "handle": "mini-box",
      "price": "1199.00",
      "compare_at_price": "1945.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4549.png?v=1785072113",
      "variant_id": 50647857856764,
      "available": true
    },
    {
      "id": 9405015589116,
      "title": "Shrimp Ramen Bundle",
      "handle": "shrimp-ramen-bundle",
      "price": "759.00",
      "compare_at_price": "863.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.28.45PM.jpg?v=1785076310",
      "variant_id": 50647975297276,
      "available": true
    },
    {
      "id": 9364476559612,
      "title": "Medium Shrimp 400g + Seafood Mix 500g — FREE Calamari Rings 500g",
      "handle": "shrimp-seafood-mix-combo",
      "price": "948.00",
      "compare_at_price": "1249.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4076.png?v=1782230516",
      "variant_id": 49220473225468,
      "available": true
    },
    {
      "id": 9352804270332,
      "title": "Large Shell-On Shrimp Twin-Pack — Buy 1, Get 2nd at 50% OFF! (2kg)",
      "handle": "large-shell-on-shrimp-twin-pack-buy-1-get-2nd-at-50-off-2kg",
      "price": "1498.00",
      "compare_at_price": "1998.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/AF8D7A31-DB4B-4984-BF1C-401DA712A3E9.png?v=1781038817",
      "variant_id": 49176440766716,
      "available": true
    },
    {
      "id": 9347598614780,
      "title": "Super Jumbo Shrimp - (Peeled - 1000g)",
      "handle": "super-jumbo-shrimp-peeled-1000g",
      "price": "1499.00",
      "compare_at_price": "1699.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4416.png?v=1783997415",
      "variant_id": 49150749999356,
      "available": true
    },
    {
      "id": 9347599171836,
      "title": "Super Jumbo Shrimp - (Peeled - 400g)",
      "handle": "super-jumbo-shrimp-peeled-400g",
      "price": "749.00",
      "compare_at_price": "849.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4416.png?v=1783997415",
      "variant_id": 49150751834364,
      "available": true
    },
    {
      "id": 9347602841852,
      "title": "Large Shrimp - (Peeled - 1000g)",
      "handle": "large-shrimp-peeled-1000g",
      "price": "1249.00",
      "compare_at_price": "1399.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4415.png?v=1783997202",
      "variant_id": 49150760222972,
      "available": true
    },
    {
      "id": 9347603103996,
      "title": "Medium - Shrimp - (Peeled - 1000g)",
      "handle": "medium-small-shrimp-peeled-1000g",
      "price": "1049.00",
      "compare_at_price": "1199.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4417.png?v=1783997539",
      "variant_id": 49150760976636,
      "available": true
    },
    {
      "id": 9347603857660,
      "title": "Medium Shrimp - (Peeled - 400g)",
      "handle": "medium-shrimp-peeled-400g",
      "price": "549.00",
      "compare_at_price": "649.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4417.png?v=1783997539",
      "variant_id": 49150765236476,
      "available": true
    },
    {
      "id": 9347603562748,
      "title": "Small Shrimp - (Peeled - 1000g)",
      "handle": "small-shrimp-peeled-1000g",
      "price": "999.00",
      "compare_at_price": "1099.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4418.png?v=1783997739",
      "variant_id": 49150763172092,
      "available": true
    },
    {
      "id": 9347611197692,
      "title": "Seafood mix - (500g)",
      "handle": "seafood-mix-500g",
      "price": "399.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4064.png?v=1782081580",
      "variant_id": 49150781456636,
      "available": true
    },
    {
      "id": 9347605364988,
      "title": "Small Shrimp - (Peeled - 400g)",
      "handle": "small-shrimp-peeled-400g",
      "price": "399.00",
      "compare_at_price": "499.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4418.png?v=1783997739",
      "variant_id": 49150767399164,
      "available": true
    },
    {
      "id": 9347605987580,
      "title": "Large Shrimp (Shell on - 1000g)",
      "handle": "large-shrimp-shell-on-1000g",
      "price": "999.00",
      "compare_at_price": "0.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/4D5F7461-39F4-44B7-865E-F5414B3D6143.png?v=1780865830",
      "variant_id": 49150768644348,
      "available": true
    },
    {
      "id": 9375022285052,
      "title": "Sahel Box 1 — Premium Grill Night",
      "handle": "sahel-box-1",
      "price": "2919.00",
      "compare_at_price": "4937.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4196.png?v=1783125726",
      "variant_id": 49247590908156,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    },
    {
      "id": 9404471804156,
      "title": "Buy 1 kg super jumbo shrimp get 100g smoked salmon slices FREE",
      "handle": "buy-1-kg-super-jumbo-shrimp-get-100g-smoked-salmon-slices-free",
      "price": "1499.00",
      "compare_at_price": "1748.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4537.png?v=1785017348",
      "variant_id": 50646196355324,
      "available": true
    },
    {
      "id": 9404958376188,
      "title": "Buy 1 large shrimp 1kg get 1 mussels meat 500g FREE",
      "handle": "buy-1-large-shrimp-1kg-get-1-mussels-meat-500g-free",
      "price": "1249.00",
      "compare_at_price": "1528.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.56.39PM.jpg?v=1785074291",
      "variant_id": 50647916937468,
      "available": true
    }
  ],
  "sea_fruits": [
    {
      "id": 9375022285052,
      "title": "Sahel Box 1 — Premium Grill Night",
      "handle": "sahel-box-1",
      "price": "2919.00",
      "compare_at_price": "4937.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4196.png?v=1783125726",
      "variant_id": 49247590908156,
      "available": true
    },
    {
      "id": 9374996627708,
      "title": "Jumbo Lobster Tail (450–500g)",
      "handle": "jumbo-lobster-tail",
      "price": "1599.00",
      "compare_at_price": "3200.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4191.png?v=1786369120",
      "variant_id": 49247539003644,
      "available": true
    },
    {
      "id": 9347611197692,
      "title": "Seafood mix - (500g)",
      "handle": "seafood-mix-500g",
      "price": "399.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4064.png?v=1782081580",
      "variant_id": 49150781456636,
      "available": true
    },
    {
      "id": 9347609002236,
      "title": "Calamari rings - (500g)",
      "handle": "calamari-rings-500g",
      "price": "299.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4063.png?v=1782081506",
      "variant_id": 49150778507516,
      "available": true
    },
    {
      "id": 9364476559612,
      "title": "Medium Shrimp 400g + Seafood Mix 500g — FREE Calamari Rings 500g",
      "handle": "shrimp-seafood-mix-combo",
      "price": "948.00",
      "compare_at_price": "1249.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4076.png?v=1782230516",
      "variant_id": 49220473225468,
      "available": true
    },
    {
      "id": 9347612279036,
      "title": "Crab Sticks - 45% Surimi (250g)",
      "handle": "crab-sticks-45-surimi",
      "price": "159.00",
      "compare_at_price": "0.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/898B1B2B-5287-4BF3-947C-845648C0FC67.png?v=1780864299",
      "variant_id": 49150785814780,
      "available": true
    },
    {
      "id": 9347608379644,
      "title": "Mussels Meat (500g)",
      "handle": "mussels-meat-500g",
      "price": "279.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/C337E6BB-57F7-4F8D-A4B7-0D0393A3AA04.png?v=1780864804",
      "variant_id": 49150774706428,
      "available": true
    },
    {
      "id": 9347607920892,
      "title": "Half Shell Mussels (500g)",
      "handle": "half-shell-mussels-500g",
      "price": "249.00",
      "compare_at_price": "339.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4065.png?v=1782082637",
      "variant_id": 49150773592316,
      "available": true
    },
    {
      "id": 9347607068924,
      "title": "Full Shell Mussels - (1Kg)",
      "handle": "full-shell-mussels-1kg",
      "price": "549.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/DE91AA29-F238-4621-B043-2C79AAB57178.png?v=1780864699",
      "variant_id": 49150771036412,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9376794575100,
      "title": "4 Packs Crab Sticks (45% Surimi) - Value Sushi Pack 250g each",
      "handle": "4-packs-crab-sticks-45-surimi-value-sushi-pack-250g-each",
      "price": "499.00",
      "compare_at_price": "636.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.17.27PM.jpg?v=1783369115",
      "variant_id": 49256425029884,
      "available": true
    },
    {
      "id": 9376799457532,
      "title": "whole calamari tubes 1 KG",
      "handle": "whole-calamari-tubes-1-kg",
      "price": "319.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.33.02PM.jpg?v=1783370041",
      "variant_id": 49256437678332,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    },
    {
      "id": 9401164759292,
      "title": "Tuna Fish Saku Sashimi - 300 - 500gm",
      "handle": "tuna-fish-saku-sashimi-300-500gm",
      "price": "499.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/F46B0EF0-0321-4954-AF16-0D34CB557065.png?v=1784780075",
      "variant_id": 50526485086460,
      "available": true
    },
    {
      "id": 9404907225340,
      "title": "Mini Box — Weeknight Starter",
      "handle": "mini-box",
      "price": "1199.00",
      "compare_at_price": "1945.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4549.png?v=1785072113",
      "variant_id": 50647857856764,
      "available": true
    },
    {
      "id": 9404958376188,
      "title": "Buy 1 large shrimp 1kg get 1 mussels meat 500g FREE",
      "handle": "buy-1-large-shrimp-1kg-get-1-mussels-meat-500g-free",
      "price": "1249.00",
      "compare_at_price": "1528.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.56.39PM.jpg?v=1785074291",
      "variant_id": 50647916937468,
      "available": true
    },
    {
      "id": 9404978102524,
      "title": "Half-Shell Mussels 500g + Oyster Sauce 280ml",
      "handle": "half-shell-mussels-500g-1-oyster-sauce-280ml",
      "price": "408.00",
      "compare_at_price": "448.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.06.52PM.jpg?v=1785074839",
      "variant_id": 50647937319164,
      "available": true
    },
    {
      "id": 9436676522236,
      "title": "Seafood mix (500g) - 2 packs offer",
      "handle": "seafood-mix-500g-2-packs-offer",
      "price": "599.00",
      "compare_at_price": "798.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4814.png?v=1787080016",
      "variant_id": 50995273466108,
      "available": true
    },
    {
      "id": 9436731179260,
      "title": "Full shell mussels 500 g",
      "handle": "full-shell-mussels-500-g",
      "price": "229.00",
      "compare_at_price": "279.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/DE91AA29-F238-4621-B043-2C79AAB57178.png?v=1780864699",
      "variant_id": 50995730546940,
      "available": true
    }
  ],
  "sauces": [
    {
      "id": 9386801037564,
      "title": "Teriyaki Sauce - 500 ml",
      "handle": "teriyaki-sauce-500-ml",
      "price": "159.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4403.png?v=1786366890",
      "variant_id": 49787516649724,
      "available": true
    },
    {
      "id": 9405015589116,
      "title": "Shrimp Ramen Bundle",
      "handle": "shrimp-ramen-bundle",
      "price": "759.00",
      "compare_at_price": "863.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.28.45PM.jpg?v=1785076310",
      "variant_id": 50647975297276,
      "available": true
    },
    {
      "id": 9404978102524,
      "title": "Half-Shell Mussels 500g + Oyster Sauce 280ml",
      "handle": "half-shell-mussels-500g-1-oyster-sauce-280ml",
      "price": "408.00",
      "compare_at_price": "448.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.06.52PM.jpg?v=1785074839",
      "variant_id": 50647937319164,
      "available": true
    },
    {
      "id": 9386853433596,
      "title": "Panko Bread Crumbs -1 kg",
      "handle": "panko-bread-crumbs-1-kg",
      "price": "339.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4413.png?v=1783996360",
      "variant_id": 49791256396028,
      "available": true
    },
    {
      "id": 9386849239292,
      "title": "Chopsticks - 25 Pcs + Helpers - 5 Pcs",
      "handle": "chopsticks-25-pcs-helpers-5-pcs",
      "price": "109.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4411.png?v=1783996090",
      "variant_id": 49790852038908,
      "available": true
    },
    {
      "id": 9386841768188,
      "title": "Sesame Oil - 625 ml",
      "handle": "sesame-oil-625-ml",
      "price": "569.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4409.png?v=1786363059",
      "variant_id": 49790348460284,
      "available": true
    },
    {
      "id": 9386835509500,
      "title": "Glass Noodles - 250 gm",
      "handle": "glass-noodles-250-gm",
      "price": "129.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4407.png?v=1783995514",
      "variant_id": 49789500129532,
      "available": true
    },
    {
      "id": 9386793533692,
      "title": "Oyster Sauce - 280 ml",
      "handle": "oyster-sauce-280-ml",
      "price": "109.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4401.png?v=1783994569",
      "variant_id": 49786921451772,
      "available": true
    },
    {
      "id": 9386770071804,
      "title": "White Rice Vinegar - 500 ml",
      "handle": "white-rice-vinegar-500-ml",
      "price": "159.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4389.png?v=1783993330",
      "variant_id": 49784036163836,
      "available": true
    },
    {
      "id": 9386766205180,
      "title": "Premium Soy Sauce – 150 ml",
      "handle": "premium-soy-sauce-150-ml",
      "price": "125.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4387.png?v=1783993075",
      "variant_id": 49783479763196,
      "available": true
    },
    {
      "id": 9386758504700,
      "title": "Sushi Vinegar - 150 ml",
      "handle": "sushi-vinegar-150-ml",
      "price": "75.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4385.png?v=1783992743",
      "variant_id": 49782385869052,
      "available": true
    },
    {
      "id": 9386750574844,
      "title": "FF Korean Noodles - 380 gm",
      "handle": "ff-korean-noodles-380-gm",
      "price": "189.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4383.png?v=1783992161",
      "variant_id": 49781389230332,
      "available": true
    }
  ],
  "bundles": [
    {
      "id": 9375022285052,
      "title": "Sahel Box 1 — Premium Grill Night",
      "handle": "sahel-box-1",
      "price": "2919.00",
      "compare_at_price": "4937.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4196.png?v=1783125726",
      "variant_id": 49247590908156,
      "available": true
    },
    {
      "id": 9347585802492,
      "title": "Salmon Fillet Whole Side",
      "handle": "salmon-fillet-whole-side",
      "price": "1875.00",
      "compare_at_price": "2100.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4088.png?v=1782238128",
      "variant_id": 49150711628028,
      "available": true
    },
    {
      "id": 9352803287292,
      "title": "Buy 5 packs salmon portions (200g)",
      "handle": "the-ultimate-salmon-protein-gourmet-bundle",
      "price": "1299.00",
      "compare_at_price": "1745.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsApp_Image_2026-06-20_at_8.28.40_PM.jpg?v=1781980147",
      "variant_id": 49176436998396,
      "available": true
    },
    {
      "id": 9364476559612,
      "title": "Medium Shrimp 400g + Seafood Mix 500g — FREE Calamari Rings 500g",
      "handle": "shrimp-seafood-mix-combo",
      "price": "948.00",
      "compare_at_price": "1249.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4076.png?v=1782230516",
      "variant_id": 49220473225468,
      "available": true
    },
    {
      "id": 9352804270332,
      "title": "Large Shell-On Shrimp Twin-Pack — Buy 1, Get 2nd at 50% OFF! (2kg)",
      "handle": "large-shell-on-shrimp-twin-pack-buy-1-get-2nd-at-50-off-2kg",
      "price": "1498.00",
      "compare_at_price": "1998.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/AF8D7A31-DB4B-4984-BF1C-401DA712A3E9.png?v=1781038817",
      "variant_id": 49176440766716,
      "available": true
    },
    {
      "id": 9352779497724,
      "title": "Premium Salmon Trimmings — 1kg 4 packs * 250g",
      "handle": "premium-salmon-trimmings-buy-3-get-1-free-value-pack",
      "price": "899.00",
      "compare_at_price": "1116.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/411BF9D6-2BA0-4AEA-8D9F-E626CEE1998F.png?v=1783410399",
      "variant_id": 49176380801276,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9376794575100,
      "title": "4 Packs Crab Sticks (45% Surimi) - Value Sushi Pack 250g each",
      "handle": "4-packs-crab-sticks-45-surimi-value-sushi-pack-250g-each",
      "price": "499.00",
      "compare_at_price": "636.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.17.27PM.jpg?v=1783369115",
      "variant_id": 49256425029884,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    },
    {
      "id": 9387425104124,
      "title": "Sushi Chef Box — Complete Home Sushi Kit",
      "handle": "sushi-chef-box",
      "price": "739.00",
      "compare_at_price": "959.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4426.png?v=1786366995",
      "variant_id": 49856752812284,
      "available": false
    },
    {
      "id": 9402865287420,
      "title": "Salmon fillet portions ( 2 x 200 gm )",
      "handle": "2-portions-200-gm",
      "price": "599.00",
      "compare_at_price": "698.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4525.png?v=1784854144",
      "variant_id": 50601224306940,
      "available": true
    },
    {
      "id": 9404446343420,
      "title": "Buy 4 smoked salmon slices 100g Get 100g FREE",
      "handle": "buy-4-smoked-salmon-slices-100g-get-100g-free",
      "price": "996.00",
      "compare_at_price": "1245.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4535.png?v=1785016189",
      "variant_id": 50646161981692,
      "available": true
    },
    {
      "id": 9404464562428,
      "title": "Buy 3 smoked salmon slices 200g get 200g FREE",
      "handle": "buy-3-smoked-salmon-slices-200g-get-200g-free",
      "price": "1497.00",
      "compare_at_price": "1996.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4536.png?v=1785016542",
      "variant_id": 50646183346428,
      "available": true
    },
    {
      "id": 9404471804156,
      "title": "Buy 1 kg super jumbo shrimp get 100g smoked salmon slices FREE",
      "handle": "buy-1-kg-super-jumbo-shrimp-get-100g-smoked-salmon-slices-free",
      "price": "1499.00",
      "compare_at_price": "1748.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4537.png?v=1785017348",
      "variant_id": 50646196355324,
      "available": true
    },
    {
      "id": 9404475310332,
      "title": "Buy 2 Super Jumbo Shrimp 400g — Get Medium Shrimp 400g FREE",
      "handle": "super-jumbo-shrimp-offer-2plus1",
      "price": "1498.00",
      "compare_at_price": "2047.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4538.png?v=1785066054",
      "variant_id": 50646201336060,
      "available": true
    },
    {
      "id": 9404873113852,
      "title": "Smoked Salmon Family Pack — 3×200g + 4×100g",
      "handle": "smoked-salmon-family-pack",
      "price": "2099.00",
      "compare_at_price": "2493.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4544.png?v=1785070697",
      "variant_id": 50647794712828,
      "available": true
    },
    {
      "id": 9404900344060,
      "title": "10 Salmon Fillet Portions (200g each)",
      "handle": "10-salmon-fillet-portions-200g",
      "price": "2399.00",
      "compare_at_price": "3490.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4546.png?v=1785071180",
      "variant_id": 50647848583420,
      "available": true
    },
    {
      "id": 9404907225340,
      "title": "Mini Box — Weeknight Starter",
      "handle": "mini-box",
      "price": "1199.00",
      "compare_at_price": "1945.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4549.png?v=1785072113",
      "variant_id": 50647857856764,
      "available": true
    },
    {
      "id": 9404912140540,
      "title": "Buy 2 medium shrimp 400g get 1 small shrimp 400g FREE",
      "handle": "buy-2-medium-shrimp-400g-get-1-small-shrimp-400g-free",
      "price": "1098.00",
      "compare_at_price": "1497.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.44.07PM.jpg?v=1785073503",
      "variant_id": 50647865327868,
      "available": true
    },
    {
      "id": 9404958376188,
      "title": "Buy 1 large shrimp 1kg get 1 mussels meat 500g FREE",
      "handle": "buy-1-large-shrimp-1kg-get-1-mussels-meat-500g-free",
      "price": "1249.00",
      "compare_at_price": "1528.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at3.56.39PM.jpg?v=1785074291",
      "variant_id": 50647916937468,
      "available": true
    },
    {
      "id": 9404978102524,
      "title": "Half-Shell Mussels 500g + Oyster Sauce 280ml",
      "handle": "half-shell-mussels-500g-1-oyster-sauce-280ml",
      "price": "408.00",
      "compare_at_price": "448.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.06.52PM.jpg?v=1785074839",
      "variant_id": 50647937319164,
      "available": true
    },
    {
      "id": 9405015589116,
      "title": "Shrimp Ramen Bundle",
      "handle": "shrimp-ramen-bundle",
      "price": "759.00",
      "compare_at_price": "863.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-26at4.28.45PM.jpg?v=1785076310",
      "variant_id": 50647975297276,
      "available": true
    },
    {
      "id": 9436676522236,
      "title": "Seafood mix (500g) - 2 packs offer",
      "handle": "seafood-mix-500g-2-packs-offer",
      "price": "599.00",
      "compare_at_price": "798.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4814.png?v=1787080016",
      "variant_id": 50995273466108,
      "available": true
    },
    {
      "id": 9436680552700,
      "title": "Salmon Fillet Chunk - 2 Packs OFFER",
      "handle": "salmon-fillet-chunk-2-packs-offer",
      "price": "498.00",
      "compare_at_price": "598.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4815.png?v=1787080712",
      "variant_id": 50995285917948,
      "available": true
    }
  ],
  "raw_salmon": [
    {
      "id": 9347585802492,
      "title": "Salmon Fillet Whole Side",
      "handle": "salmon-fillet-whole-side",
      "price": "1875.00",
      "compare_at_price": "2100.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4088.png?v=1782238128",
      "variant_id": 49150711628028,
      "available": true
    },
    {
      "id": 9352803287292,
      "title": "Buy 5 packs salmon portions (200g)",
      "handle": "the-ultimate-salmon-protein-gourmet-bundle",
      "price": "1299.00",
      "compare_at_price": "1745.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsApp_Image_2026-06-20_at_8.28.40_PM.jpg?v=1781980147",
      "variant_id": 49176436998396,
      "available": true
    },
    {
      "id": 9402865287420,
      "title": "Salmon fillet portions ( 2 x 200 gm )",
      "handle": "2-portions-200-gm",
      "price": "599.00",
      "compare_at_price": "698.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4525.png?v=1784854144",
      "variant_id": 50601224306940,
      "available": true
    },
    {
      "id": 9364512440572,
      "title": "Salmon Fillet Chunk (190–210g)",
      "handle": "salmon-fillet-chunk-190-210-g",
      "price": "299.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4085.png?v=1782237096",
      "variant_id": 49220607213820,
      "available": true
    },
    {
      "id": 9347594911996,
      "title": "Salmon Fillet Portion (200g)",
      "handle": "salmon-fillet-portion-200g",
      "price": "349.00",
      "compare_at_price": "399.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/39301282-A7E2-4A8A-A7B1-42102E5DBDCE.png?v=1780863597",
      "variant_id": 49150736105724,
      "available": true
    },
    {
      "id": 9347595403516,
      "title": "Salmon Steak (200g)",
      "handle": "salmon-steak-230-260g",
      "price": "299.00",
      "compare_at_price": null,
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/C0021D66-12B8-42BE-8B3B-0A4405467C8F.png?v=1780864209",
      "variant_id": 49150740136188,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    },
    {
      "id": 9404900344060,
      "title": "10 Salmon Fillet Portions (200g each)",
      "handle": "10-salmon-fillet-portions-200g",
      "price": "2399.00",
      "compare_at_price": "3490.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4546.png?v=1785071180",
      "variant_id": 50647848583420,
      "available": true
    },
    {
      "id": 9404907225340,
      "title": "Mini Box — Weeknight Starter",
      "handle": "mini-box",
      "price": "1199.00",
      "compare_at_price": "1945.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4549.png?v=1785072113",
      "variant_id": 50647857856764,
      "available": true
    },
    {
      "id": 9436680552700,
      "title": "Salmon Fillet Chunk - 2 Packs OFFER",
      "handle": "salmon-fillet-chunk-2-packs-offer",
      "price": "498.00",
      "compare_at_price": "598.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4815.png?v=1787080712",
      "variant_id": 50995285917948,
      "available": true
    }
  ],
  "sahel": [
    {
      "id": 9387425104124,
      "title": "Sushi Chef Box — Complete Home Sushi Kit",
      "handle": "sushi-chef-box",
      "price": "739.00",
      "compare_at_price": "959.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4426.png?v=1786366995",
      "variant_id": 49856752812284,
      "available": false
    },
    {
      "id": 9376814825724,
      "title": "Sahel Box 4 — The Grand Feast",
      "handle": "sahel-box-4",
      "price": "5999.00",
      "compare_at_price": "7991.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at11.24.24PM.jpg?v=1783373090",
      "variant_id": 49256926740732,
      "available": true
    },
    {
      "id": 9376802767100,
      "title": "Sahel Box 3 — Family Fry Night",
      "handle": "sahel-box-3",
      "price": "1129.00",
      "compare_at_price": "1395.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at10.44.11PM.jpg?v=1783370673",
      "variant_id": 49256445509884,
      "available": true
    },
    {
      "id": 9376718356732,
      "title": "Sahel Box 2 — Salmon Lovers",
      "handle": "sahel-box-2",
      "price": "2799.00",
      "compare_at_price": "3551.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/WhatsAppImage2026-07-06at7.58.14PM.jpg?v=1783360720",
      "variant_id": 49256155873532,
      "available": true
    },
    {
      "id": 9375022285052,
      "title": "Sahel Box 1 — Premium Grill Night",
      "handle": "sahel-box-1",
      "price": "2919.00",
      "compare_at_price": "4937.00",
      "image": "https://cdn.shopify.com/s/files/1/0792/5012/9148/files/IMG-4196.png?v=1783125726",
      "variant_id": 49247590908156,
      "available": true
    }
  ]
};
